import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnChange(props) {
  let list = useDataValue({
    context: 'parent_companies',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      if (next.id === value) return

      let item = list.find(item => item.id === value)

      next.id = value
      next.parent_company_id = item.parent_company_id
      next.division_id = item.division_id
      next.xid = item.xid
      next.mfa_token = null
      next.location_id = null
      next.for_user_id = null
    })
  }
}
